import { useEffect, useRef } from 'react';
import { DraftConfiguration } from '@/types';

export const useConfigSwitch = ({ cid }: DraftConfiguration, callback: () => void) => {
  const cidRef = useRef(cid);
  useEffect(() => {
    if (cidRef.current !== cid) {
      cidRef.current = cid;
      callback();
    }
  }, [cid, callback]);
};
